import { themeColors } from '@/theme/colors';
import { Icon, TextLink } from '@lego/connect-components-react';
import { Flex } from '@lego/klik-ui';

type UploadDropZoneProps = {
  onBrowseClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const UploadDropZone = ({ onBrowseClick }: UploadDropZoneProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap="12px"
    flex="1"
    backgroundColor={themeColors.interactive.primary.subtle.selected}
    borderRadius="8px"
    style={{
      border: `1px dashed ${themeColors.interactive.primary.enabled}`,
    }}
  >
    <span className="body-md-regular" style={{ fontWeight: 500 }}>
      Drag and drop file here or
    </span>
    <Flex alignItems="center" gap="8px">
      <TextLink
        href="#"
        variant="emphasis"
        size="medium"
        onClick={onBrowseClick}
        style={{ textDecoration: 'none' }}
      >
        <Icon
          name="folder"
          aria-label="browse"
          color="ds-color-interactive-primary-enabled"
        />
        <span style={{ verticalAlign: 'middle' }}> browse files</span>
      </TextLink>
    </Flex>
  </Flex>
);

export default UploadDropZone;
